<template>
  <div class="heat-map-container">
    <div ref="heatMap" class="heat-map"></div>
    <!-- 返回按钮，仅在显示驻马店视图时显示 -->
    <div v-if="currentView === 'zhumadian'" class="back-button" @click="goBack">
      <i class="el-icon-arrow-left"></i> 返回全国视图
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import china from '../../lib/china.json';
//import zhumadian from '../../lib/zhumadian.json'; // 假设这个文件包含驻马店的区县数据

// 注册中国地图
echarts.registerMap('china', china);

// 如果没有驻马店的区县数据，我们将使用模拟数据
const mockZhumadianDistricts = {
  type: 'FeatureCollection',
  features: [
    {
      type: 'Feature',
      properties: { name: '确山县' },
      geometry: {
        type: 'Polygon',
        coordinates: [[[114.0, 32.5], [114.5, 32.5], [114.5, 33.0], [114.0, 33.0], [114.0, 32.5]]]
      }
    },
    {
      type: 'Feature',
      properties: { name: '泌阳县' },
      geometry: {
        type: 'Polygon',
        coordinates: [[[113.5, 32.5], [114.0, 32.5], [114.0, 33.0], [113.5, 33.0], [113.5, 32.5]]]
      }
    },
    {
      type: 'Feature',
      properties: { name: '遂平县' },
      geometry: {
        type: 'Polygon',
        coordinates: [[[114.0, 32.0], [114.5, 32.0], [114.5, 32.5], [114.0, 32.5], [114.0, 32.0]]]
      }
    }
  ]
};

// 如果有实际的驻马店地图数据则使用，否则使用模拟数据
try {
  echarts.registerMap('zhumadian', zhumadian);
} catch (e) {
  echarts.registerMap('zhumadian', mockZhumadianDistricts);
}

export default {
  name: "HerbDistributionHeatMap",
  data() {
    return {
      myChart: null,
      currentView: 'china', // 当前视图：china 或 zhumadian
      nationalHerbData: [], // 全国药材数据
      zhumadianDistrictData: [], // 驻马店区县数据
      option: {}
    };
  },
  methods: {
    // 生成模拟的全国药材热力数据
    generateNationalHerbData() {
      // 模拟全国各省份的药材产量数据
      const provinces = [
        { name: '北京', value: 20 },
        { name: '天津', value: 15 },
        { name: '河北', value: 200 },
        { name: '山西', value: 180 },
        { name: '内蒙古', value: 120 },
        { name: '辽宁', value: 150 },
        { name: '吉林', value: 130 },
        { name: '黑龙江', value: 140 },
        { name: '上海', value: 30 },
        { name: '江苏', value: 220 },
        { name: '浙江', value: 210 },
        { name: '安徽', value: 250 },
        { name: '福建', value: 190 },
        { name: '江西', value: 230 },
        { name: '山东', value: 280 },
        { name: '河南', value: 350 }, // 河南省数据较高
        { name: '湖北', value: 240 },
        { name: '湖南', value: 260 },
        { name: '广东', value: 200 },
        { name: '广西', value: 180 },
        { name: '海南', value: 90 },
        { name: '重庆', value: 170 },
        { name: '四川', value: 320 },
        { name: '贵州', value: 160 },
        { name: '云南', value: 290 },
        { name: '西藏', value: 80 },
        { name: '陕西', value: 220 },
        { name: '甘肃', value: 150 },
        { name: '青海', value: 60 },
        { name: '宁夏', value: 70 },
        { name: '新疆', value: 110 },
        { name: '台湾', value: 50 },
        { name: '香港', value: 10 },
        { name: '澳门', value: 5 }
      ];
      return provinces;
    },

    // 生成驻马店区县数据
    generateZhumadianDistrictData() {
      // 驻马店各区县的药材数据
      return [
        { name: '确山县', value: 120, herbs: '夏枯草（全国最大产区，地理标志产品）', employment: 15000 },
        { name: '泌阳县', value: 95, herbs: '淫羊藿、艾草、丹参', employment: 12000 },
        { name: '遂平县', value: 80, herbs: '夏枯草、半枝莲、丹参', employment: 10000 }
      ];
    },

    // 初始化图表
    initChart() {
      this.myChart = echarts.init(this.$refs.heatMap);
      this.nationalHerbData = this.generateNationalHerbData();
      this.zhumadianDistrictData = this.generateZhumadianDistrictData();
      this.updateChart();

      // 添加点击事件处理下钻功能
      this.myChart.on('click', params => {
        if (this.currentView === 'china' && params.name === '河南') {
          // 点击河南省时，尝试显示驻马店市
          this.currentView = 'zhumadian';
          this.updateChart();
        } else if (this.currentView === 'zhumadian') {
          // 点击驻马店市区县时的处理
          console.log('点击了区县:', params.name);
        }
      });

      // 监听窗口大小变化，重绘图表
      window.addEventListener('resize', this.handleResize);
    },

    // 更新图表配置
    updateChart() {
      let option = {
        title: {
          text: this.currentView === 'china' ? '全国药材资源分布热力图' : '驻马店市药材资源分布',
          textStyle: {
            color: '#fff',
            fontSize: 16
          },
          left: 'center'
        },
        tooltip: {
          trigger: 'item',
          textStyle: {
            color: '#fff'
          },
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
          formatter: params => {
            if (this.currentView === 'china') {
              if (params.name === '河南') {
                return `${params.name}<br/>药材产量: ${params.value}<br/>重点区域: 驻马店市`;
              }
              return `${params.name}<br/>药材产量: ${params.value}`;
            } else {
              const district = this.zhumadianDistrictData.find(d => d.name === params.name);
              if (district) {
                return `${params.name}<br/>药材: ${district.herbs}<br/>附加值: ${district.value}万元<br/>就业人数: ${district.employment}人`;
              }
              return `${params.name}`;
            }
          }
        },
        legend: {
          show: false
        },
        visualMap: {
          min: 0,
          max: this.currentView === 'china' ? 400 : 150,
          left: 'left',
          top: 'bottom',
          text: ['高', '低'],
          textStyle: {
            color: '#fff'
          },
          calculable: true,
          inRange: {
            color: ['#e6f7ff', '#bae7ff', '#91d5ff', '#69c0ff', '#40a9ff', '#1890ff', '#096dd9']
          }
        },
        series: [
          {
            name: '药材产量',
            type: 'map',
            mapType: this.currentView,
            roam: true,
            zoom: this.currentView === 'china' ? 1.2 : 1,
            label: {
              show: true,
              color: '#fff'
            },
            emphasis: {
              label: {
                color: '#fff'
              },
              itemStyle: {
                areaColor: '#ff7f50'
              }
            },
            itemStyle: {
              areaColor: '#134f71',
              borderColor: '#fff',
              borderWidth: 1
            },
            data: this.currentView === 'china' ? this.nationalHerbData : this.zhumadianDistrictData
          }
        ]
      };

      // 为河南省驻马店市添加特殊样式（高亮显示）
      if (this.currentView === 'china') {
        option.series[0].emphasis.itemStyle = {
          areaColor: '#ff7f50'
        };
      }

      this.myChart.setOption(option);
    },

    // 处理窗口大小变化
    handleResize() {
      if (this.myChart) {
        this.myChart.resize();
      }
    },

    // 返回上一级视图
    goBack() {
      if (this.currentView === 'zhumadian') {
        this.currentView = 'china';
        this.updateChart();
      }
    }
  },
  mounted() {
    this.initChart();
  },
  beforeDestroy() {
    if (this.myChart) {
      this.myChart.dispose();
    }
    window.removeEventListener('resize', this.handleResize);
  }
};
</script>

<style lang="less" scoped>
.heat-map-container {
  width: 100%;
  height: 100%;
  position: relative;
}

.heat-map {
  width: 100%;
  height: 100%;
  position: relative;
}

.back-button {
  position: absolute;
  top: 20px;
  left: 20px;
  z-index: 1000;
  background-color: rgba(0, 140, 255, 0.8);
  color: white;
  border: none;
  padding: 10px 15px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  transition: all 0.3s;

  &:hover {
    background-color: rgba(0, 140, 255, 1);
    transform: translateX(-2px);
  }

  i {
    margin-right: 5px;
  }
}
</style>